import { render } from "./CreateSupplierForm.vue?vue&type=template&id=01fd9a6a&scoped=true&ts=true"
import script from "./CreateSupplierForm.vue?vue&type=script&lang=ts"
export * from "./CreateSupplierForm.vue?vue&type=script&lang=ts"

import "./CreateSupplierForm.vue?vue&type=style&index=0&id=01fd9a6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01fd9a6a"]])

export default __exports__